export enum GamesServiceUrlPaths {
    GetTournamentFormURL = '/{gameId}/tournament_form',
}